import { useMemo } from 'react';

/**
 * Custom hook for access control based on SCREEN_RIGHT
 * @param {string} access - The SCREEN_RIGHT value ("FULL_ACCESS", "VIEW_ONLY", "NONE")
 * @returns {object} - { isFullAccess: boolean, isReadOnly: boolean }
 */
export const useAccessControl = (access) => {
  return useMemo(() => {
    const isFullAccess = access === "Full Access";
    const isReadOnly = !isFullAccess;
    return { isFullAccess, isReadOnly };
  }, [access]);
};